import React from 'react';
import NavBar from './NavBar';
import Footer from './Footer';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

const useStyles = makeStyles({
  main: {
    backgroundColor: "#ffffff",
    padding: "0px 24px 70px",
    marginTop: "40px",
  },
  container: {
    backgroundColor: "#fbfdfe",

  },
  mainContainter: {
    minHeight: "calc(100vh - 102px)",
    overflow: "hidden",
    display: "block",
    position: "relative",
    paddingBottom: "243px",
    '@media (max-width:767px)': {
      paddingBottom: "340px",
    },
  },
  footer: {
    position: "absolute !important",
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
      position: "relative !important",
    },
    bottom: "0 !important",
  },
})

export default function Layout(props) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <NavBar />
      <Container maxWidth="lg" className={classes.mainContainter}>
        <div className={classes.main}>
          {props.children}
        </div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </Container>
    </div>
  );
}
